import Stack from '@mui/material/Stack';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import DangerousOutlinedIcon from '@mui/icons-material/DangerousOutlined';

import { useHistory } from "react-router-dom";

const ColorButton = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: blue[800],
    '&:hover': {
        backgroundColor: blue[1000],
    },
}));


export default function CustomizedDemoLicense() {
  const history = useHistory();
  const routeChange = () =>{ 
    let path = '/demo' 
    history.push(path);
  }

    return (
        <Stack spacing={2} direction="row">
            <ColorButton
                style={{ minWidth: '100%', minHeight: '3.5rem' }}
                startIcon={<DangerousOutlinedIcon></DangerousOutlinedIcon>}
                onClick={routeChange}
                size="larger" variant="contained">Número de demonstrações:{4} 
            </ColorButton>
        </Stack>
    );
}